<template>
    <div>
        <div class="wrapper text text--align-center" style="margin-top: 85px;">
            <div class="box box--running">
                <div class="box__background-width" style="left: 10%;"></div>
            </div>
            <span class="text text--big text--red number">
                <strong id="speedValue">00</strong>
            </span>
            <p class="text text--red margin margin--bottom-20 text-info">
                <span v-html="currentData.copyRed"></span> <br>
                <span id="afterFirstActionCorrect" style="display: none;" v-html="currentData.copyRedAfterFirstCorrect"></span>
            </p>
            <button class="button" disabled="disabled" id="nextButton" v-if="stock">
                <router-link :to="'/activityType/' + this.$route.params.id + '/form'">{{currentData.buttonCopy}}</router-link>
            </button>
            <button class="button button-home" disabled="disabled" id="nextButton" v-if="!stock">
                <router-link :to="'/'">ZURÜCK ZUR STARTSEITE</router-link>
            </button>
        </div>
        <svg width="0" height="0">
            <defs>
                <clipPath id="triangle">
                    <polygon  points="190 0 190 118.724407 0 118.724407" />
                </clipPath>
            </defs>
        </svg>
    </div>
</template>
<script>

    import data from '../assets/data/data';

    import jQuery from "jquery";
    window.$ = window.jQuery = jQuery;
    import config from '../assets/data/config.json';
    import axios from 'axios';

    import podo from '../../js/podo.js';
    import running from '../../js/running.js';

    export default {
        name: 'GameRunning',

        data: function () {
            return {
                data: data,
                stock: false,
                availableData:  {
                    yoga: {
                        availableCount: 0
                    },
                    workout: {
                        availableCount: 0
                    },
                    running: {
                        availableCount: 0
                    }
                }
            }
        },
        mounted: function(){
            axios.get(config.endpoint.available).then(response => {

                if(response.data.availableData){
                    this.availableData = response.data.availableData;
                }
                this.checkAvailableProducts();


            }).catch((e) => {

            });
            window.runningInstance = new window.Running();
            window.runningInstance.init();
            window.addEventListener('permissionDeniedMicEvent', (e) => {
                this.$router.push({ path: '/alert' });
            }, false);
        },
        methods: {
            checkAvailableProducts: function () {

                const allProducts = this.availableData;
                const emptyProducts = Object.keys(allProducts).filter(keyName => {
                    let currentValue = allProducts[keyName];
                    return currentValue.availableCount < 1
                });

                if(emptyProducts.length == Object.keys(allProducts).length) {

                } else {
                    this.stock = true;
                }

            }

        },
        computed: {
            currentData: function () {
                return this.data.activities[this.$route.params.id].game;
            }
        },
        beforeDestroy: function(){
            window.runningInstance.destroy();
            window.runningInstance = undefined;
            window.removeEventListener('permissionDeniedMicEvent', (e) => {
            }, false);
        }

    }


</script>
<style lang="scss" scope="local">
    .box--running {

        position: relative;
        width: 190px;
        height: 150px;

        margin: auto;
        transform: translateZ(0);
        -webkit-clip-path: url(#triangle);
        clip-path: url(#triangle);

        background-color: #e1e2dc;

    }

    .box__background-width {
        z-index: -1;
        border-radius: 0;
    }
</style>
